export default __webpack_public_path__ + "static/media/Certificate of RTA under 74(5).71a5c0a1.pdf";